import type { CreateTransferBatchInput } from '@frameio/graphql-client/generated';
import type { ProcessedFileItem } from './getUploadItemsFromEntry';
import type { UploadFileItem, UploadFolderItem } from './uploadItem';

type TransferBatchMetadata = Pick<
  CreateTransferBatchInput,
  'name' | 'topLevelFolderCount' | 'topLevelFileCount'
>;

type WithTempParentId = Pick<
  UploadFileItem | UploadFolderItem | ProcessedFileItem,
  'tempParentId'
>;

export const generateTransferBatchMetadata = (
  fileItems: UploadFileItem[] | ProcessedFileItem[],
  folderItems: UploadFolderItem[]
): TransferBatchMetadata => {
  const topLevelFileCount = getTopLevelItemCount(fileItems);
  const topLevelFolderCount = getTopLevelItemCount(folderItems);

  let name = '';

  if (topLevelFileCount === 1 && topLevelFolderCount === 0) {
    name = getFileItemName(fileItems[0]);
  }

  if (topLevelFolderCount === 1 && topLevelFileCount === 0) {
    name = getFolderItemName(folderItems[0]);
  }

  return {
    name,
    topLevelFileCount,
    topLevelFolderCount,
  };
};

const getTopLevelItemCount = (items: WithTempParentId[]) =>
  items?.length !== 0
    ? items.filter(({ tempParentId }) => !tempParentId).length
    : 0;

const getFolderItemName = (folderItem: UploadFolderItem) => folderItem?.name;

const getFileItemName = (fileItem: UploadFileItem | ProcessedFileItem) =>
  'name' in fileItem ? fileItem?.name : fileItem?.entry?.name;
